export default __webpack_public_path__ + "static/media/user1.74cc1cbe.png";